import { DictItem, NameFilter } from '@spilca/order_ts/v1/order/enum_pb';

// eslint-disable-next-line import/prefer-default-export
export const convertToNameFilter = (
  filterData: string[],
  typeId: number
): NameFilter[] =>
  filterData.map((item) => {
    const f = new NameFilter();
    f.setId(Number(item));
    f.setTypeId(typeId);
    return f;
  });

export const convertFiltersDict = (data: DictItem.AsObject[]) =>
  data.reduce((acc, item) => ({ ...acc, [item.id]: item.name }), {});
